module.exports = __webpack_public_path__ + "static/media/32.d0f52798.mp3";